import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useStore } from 'react-redux';
import { storeCollege, getColleges, updateCollege, getCollegeCategories, getCountries } from './../../apis/services';
import { Modal } from 'react-bootstrap';
import { Checkbox } from "primereact/checkbox";
import { useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from "primereact/inputswitch";
import { setShowDeleteDialog } from '../../redux/reducer';
import DeleteModalContent from '../../commons/DeleteModalContent';
import { Link } from 'react-router-dom';
import Select from 'react-select';
const Colleges = () => {
    const { t } = useTranslation();
    const store = useStore();
    const [colleges, setColleges] = useState([]);
    const [showAddCollegesModal, setShowAddCollegesModal] = useState(false);
    const [showEditCollegesModal, setShowEditCollegesModal] = useState({ show: false, item: '' });
    useEffect(() => {
        loadColleges();
    }, []);
    const loadColleges = async () => {
        try {
            const res = await getColleges();
            setColleges(res.data.colleges);
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <div>
            <div className="glass-card p-3">
                <div className="d-flex jcsb">
                    <div className='mt-2 mb-2'>
                        <h4>{t('manage_colleges')}</h4>
                    </div>
                    <div className='p-2 d-flex'>
                        <Button className='p-btn mx-1'
                            onClick={() => {
                                setShowAddCollegesModal(true);
                            }}
                        > {t('add_college')}</Button>
                        <Link to='/colleges/categories' className='link-btn mx-1'>{t('college_categories')}</Link>
                        <Link to='/colleges/countries' className='link-btn mx-1'>{t('countries')}</Link>
                    </div>
                </div>
                <Modal
                    show={showAddCollegesModal}
                >
                    <div className='p-4'>
                        <AddColleges
                            submit={() => {
                                setShowAddCollegesModal(false);
                                loadColleges();
                            }}
                            cancel={() => {
                                setShowAddCollegesModal(false);
                            }}
                        />
                    </div>
                </Modal>
                <Modal
                    show={showEditCollegesModal.show}
                >
                    <div className='p-4'>
                        <EditColleges
                            submit={() => {
                                setShowEditCollegesModal({ show: false, item: '' });
                                loadColleges();
                            }}
                            cancel={() => {
                                setShowEditCollegesModal({ show: false, item: '' });
                            }}
                            item={showEditCollegesModal.item}
                        />
                    </div>
                </Modal>
                <DeleteModalContent
                    reload={() => {
                        loadColleges();
                    }}
                />
                <div className="data-table mt-2">
                    <DataTable
                        value={colleges}
                        paginator
                        rows={10}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 25, 50]}
                        dataKey="id"
                        selectionMode="checkbox"
                        filterDisplay="menu"
                        emptyMessage={t('data_not_available')}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    >

                        <Column
                            field="name"
                            header={t('name')}
                            sortable
                        />
                        <Column
                            field="code"
                            header={t('code')}
                            sortable
                        />
                        <Column
                            field="category_name"
                            header={t('type')}
                            sortable
                        />
                        <Column
                            field="country_name"
                            header={t('country')}
                            sortable
                        />

                        <Column
                            header={t('status')}
                            sortField='status'
                            sortable
                            body={(row) => {
                                return (
                                    <InputSwitch checked={row.status === 1 ? true : false} />
                                )
                            }}
                        />
                        <Column
                            header={t('actions')}
                            body={(row) => {
                                return (
                                    <div className='d-flex'>
                                        <Button
                                            onClick={(e) => {
                                                setShowEditCollegesModal({ show: true, item: row });
                                            }}
                                            className='icon-btn mx-1' severity='primary' id="edit-btn">
                                            <span className="material-symbols-outlined">
                                                edit
                                            </span>
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                store.dispatch(setShowDeleteDialog({ show: true, url: '/colleges/delete/' + row.id }))
                                            }}
                                            className='icon-btn mx-1' severity='danger' id="edit-btn">
                                            <span className="material-symbols-outlined">
                                                delete
                                            </span>
                                        </Button>
                                    </div>
                                )
                            }}
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    );

}

const AddColleges = (props) => {
    const { t } = useTranslation();
    const [collegeTitle, setCollegeTitle] = useState();
    const [code, setCode] = useState();
    const [status, setStatus] = useState(true);
    const [type, setType] = useState();
    const [country, setCountry] = useState();
    const [countries, setCountries] = useState([]);
    const [types, setTypes] = useState([]);
    useEffect(() => {
        loadCategories();
        loadCountries();

    }, []);
    const loadCategories = async () => {
        try {
            let params = {
                active: 1,
            }
            const res = await getCollegeCategories(params);
            setTypes(res.data.college_categories);
        } catch (error) {

        }
    }
    const loadCountries = async () => {
        try {
            let params = {
                active: 1,
            }
            const res = await getCountries(params);
            setCountries(res.data.countries	);
        } catch (error) {

        }
    }
    const handleAddColleges = async () => {
        try {
            let data = {
                collegeTitle: collegeTitle,
                status: status,
                code: code,
                country: country.id,
                type: type.id
            }
            await storeCollege(data);
            props.submit();
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <form action=""
            onSubmit={(e) => {
                e.preventDefault();
                handleAddColleges();
            }}
        >
            <div className="row">
                <div className="col-12">
                    <div className="d-flex jcsb align-items-center">
                        <h5 className='mt-2 mb-3 opacity'>{t('add_college')}</h5>
                        <Button raised className='icon-btn' severity='secondary' type='button'
                            onClick={() => {
                                props.cancel();
                            }}
                        >
                            <span className="material-symbols-outlined">
                                cancel
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="collegeTitle" className='required mb-1' >{t('name')}</label>
                        <input type="text" id="collegeTitle" className='form-control' required
                            value={collegeTitle}
                            onChange={(e) => { setCollegeTitle(e.target.value) }}
                        />
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="code" className='required mb-1' >{t('code')}</label>
                        <input type="text" id="code" className='form-control' required
                            value={code}
                            onChange={(e) => { setCode(e.target.value) }}
                        />
                    </div>
                </div>

                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="type" className='required mb-1' >{t('type')}</label>
                        <Select
                            getOptionLabel={(l) => l.category_name}
                            getOptionValue={(v) => v.id}
                            options={types}
                            value={type}
                            onChange={(e) => {
                                setType(e);
                            }}
                            placeholder={t('select')}
                        />
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="country" className='required mb-1' >{t('country')}</label>
                        <Select
                            options={countries}
                            value={country}
                            onChange={(e) => {
                                setCountry(e);
                            }}
                            getOptionLabel={(l) => l.country_name}
                            getOptionValue={(v) => v.id}
                            placeholder={t('select')}
                        />
                    </div>
                </div>
                <div className="col-md-12 mt-2">
                    <div className="d-flex">
                        <div className="flex align-items-center">
                            <Checkbox inputId="status" name="status" checked={status} className=''
                                onChange={() => {
                                    setStatus(!status);
                                }}
                            />
                            <label htmlFor="status" className="ml-2 mx-2">{t('enable_for_use')}</label>
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <Button type='submit' className='p-btn'>{t('save')}</Button>
                </div>
            </div>
        </form>
    );
}
const EditColleges = (props) => {
    const { t } = useTranslation();
    const item = props.item;
    const [collegeTitle, setCollegeTitle] = useState(item.name);
    const [code, setCode] = useState(item.code);
    const [status, setStatus] = useState(item.status === 1 ? true : false);
    const [type, setType] = useState();
    const [country, setCountry] = useState();
    const [countries, setCountries] = useState([]);
    const [types, setTypes] = useState([]);
    
    useEffect(() => {
        loadCategories();
        loadCountries();

    }, []);
    const handleEditColleges = async () => {
        try {
            let data = {
                id: item.id,
                collegeTitle: collegeTitle,
                status: status,
                code: code,
                country: country.id,
                type: type.id
            }
            await updateCollege(data);
            props.submit();
        } catch (error) {
            console.log(error);
        }
    }
    const loadCategories = async () => {
        try {
            let params = {
                active: 1,
            }
            const res = await getCollegeCategories(params);
            setType(res.data.college_categories.find((e)=> e.id === item.type));
            setTypes(res.data.college_categories);
        } catch (error) {

        }
    }
    const loadCountries = async () => {
        try {
            let params = {
                active: 1,
            }
            const res = await getCountries(params);
            setCountry(res.data.countries.find((e)=> e.id === item.country));
            setCountries(res.data.countries	);
        } catch (error) {

        }
    }
    return (
        <form action=""
            onSubmit={(e) => {
                e.preventDefault();
                handleEditColleges();
            }}
        >
            <div className="row">
                <div className="col-12">
                    <div className="d-flex jcsb align-items-center">
                        <h5 className='mt-2 mb-3 opacity'>{t('edit_college')}</h5>
                        <Button raised className='icon-btn' severity='secondary' type='button'
                            onClick={() => {
                                props.cancel();
                            }}
                        >
                            <span className="material-symbols-outlined">
                                cancel
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="collegeTitle" className='required mb-1' >{t('name')}</label>
                        <input type="text" id="collegeTitle" className='form-control' required
                            value={collegeTitle}
                            onChange={(e) => { setCollegeTitle(e.target.value) }}
                        />
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="code" className='required mb-1' >{t('code')}</label>
                        <input type="text" id="code" className='form-control' required
                            value={code}
                            onChange={(e) => { setCode(e.target.value) }}
                        />
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="type" className='required mb-1' >{t('type')}</label>
                        <Select
                            getOptionLabel={(l) => l.category_name}
                            getOptionValue={(v) => v.id}
                            options={types}
                            value={type}
                            onChange={(e) => {
                                setType(e);
                            }}
                        />
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="country" className='required mb-1' >{t('country')}</label>
                        <Select
                            options={countries}
                            value={country}
                            onChange={(e) => {
                                setCountry(e);
                            }}
                            getOptionLabel={(l) => l.country_name}
                            getOptionValue={(v) => v.id}
                        />
                    </div>
                </div>
                <div className="col-md-12 mt-2">
                    <div className="d-flex">
                        <div className="flex align-items-center">
                            <Checkbox inputId="status" name="status" checked={status} className=''
                                onChange={() => {
                                    setStatus(!status);
                                }}
                            />
                            <label htmlFor="status" className="ml-2 mx-2">{t('enable_for_use')}</label>
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <Button type='submit' className='p-btn'>{t('update')}</Button>
                </div>
            </div>
        </form>
    );
}
export default Colleges;